/**
 * Group tags shared with the Android Connect app (AppConstants.java), so both
 * apps see the same lists.
 *
 * - CALL_GROUP_TAG: a group Connect can ring. The Groups tab lists only joined
 *   groups carrying it; "New group call" creates one (PRIVATE, members added
 *   after creation) and rings it with initiateCall(guid, group).
 * - MEETING_GROUP_TAG: the chat group each meeting creates (guid = session id).
 *   Tagged so it never appears in Groups; it opens from History instead.
 */
export const CALL_GROUP_TAG = 'connect-call';
export const MEETING_GROUP_TAG = 'meeting';

/**
 * The guid of a session's chat group. A lobby session id is short
 * (`a1b2-c3d4-e5f6`); a ringing-flow session id and a call-log session id
 * carry a `v1.<region>.<app>.` prefix, and dots aren't valid in a guid. The
 * last segment is the same for all three, so it is the guid everywhere.
 */
export function meetingGuid(sessionId: string): string {
  return sessionId.split('.').pop() || sessionId;
}
